// src/utils/theme.js

export const THEME = {
  // Key Actions (Sign In, User Name, Log Out)
  primary1: "text-blue-600",
  secondary1: "hover:text-blue-800",

  // Standard Nav Links (Practice, About, My Tests)
  primary2: "text-gray-700",
  secondary2: "hover:text-orange-600",

  // Dropdown List Content (Privacy, Terms, Pricing)
  primary3: "text-gray-600",
  secondary3: "hover:text-black",

  // Special Button Backgrounds
  signupBtnBg: "bg-blue-600 hover:bg-blue-700",
};